import { useNavigate } from 'react-router-dom';
import { categories } from '@/mocks/categories';

function CategoriesSection() {
  const navigate = useNavigate();

  return (
    <section className="py-16 md:py-24 bg-background-100">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="text-center mb-12 md:mb-16">
          <span className="inline-block text-sm font-semibold text-primary-400 uppercase tracking-wider mb-3">
            Catégories
          </span>
          <h2 className="font-heading font-bold text-2xl md:text-4xl text-foreground-50 mb-4">
            Trouvez ce que vous cherchez
          </h2>
          <p className="text-base md:text-lg text-foreground-400 max-w-2xl mx-auto">
            Explorez les entreprises par catégorie. Des restaurants aux banques, en passant par les cliniques et les écoles.
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {categories.map((category) => (
            <button
              key={category.id}
              onClick={() => navigate(`/directory?category=${category.slug}`)}
              className="group p-4 md:p-5 rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-400/40 hover:bg-background-50 transition-all duration-300 text-left"
            >
              <div className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-lg bg-primary-500/10 mb-3 group-hover:bg-primary-500/20 transition-colors">
                <i className={`${category.icon} text-xl text-primary-400`} />
              </div>
              <h3 className="font-heading font-semibold text-sm md:text-base text-foreground-50 mb-1">
                {category.name}
              </h3>
              <p className="text-xs text-foreground-400 hidden sm:block">
                {category.description}
              </p>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}

export default CategoriesSection;